import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

abstract class EnvironmentConfig {
  appName?: string;
  domain?: string;
  redirectUrl?: string;
  production?: boolean;
  cognitoUrl?: string;
  clientId?: string;
  userPoolId?: string;
  envName?: string;
  gmapsApiKey?: string;
  secureUploaderServiceUrl?: string;
  socialAuth?: {
    googleId?: string;
    facebookId?: string;
  };
  legacyApi?: {
    base?: string;
    host?: string;
  };
  applicationIframeConfig?: {
    url?: string;
  };
  featureFlagConfig?: {
    [key: string]: any;
  };
  showSnackbar?: boolean;
  sentryDsn?: string;
  datadog?: {
    [key: string]: any;
  };
  managerClientConfig?: {
    baseUrl?: string;
  };
  appUrls?: {
    serviceAreaAdmin?: string;
  };
  verix?: {
    clientId?: string;
    environment?: string;
  };
  [key: string]: any;
}

export class Environment extends EnvironmentConfig {}

@NgModule({
  imports: [CommonModule],
})
export class SharedEnvModule {
  static forRoot(environment: any): ModuleWithProviders<SharedEnvModule> {
    return {
      ngModule: SharedEnvModule,
      providers: [
        {
          provide: Environment,
          useValue: environment,
        },
      ],
    };
  }
}
